import Vue from "vue"
import VueRouter, { RouteConfig } from "vue-router"
import paths from "./paths"
const globals = require("../globals").default
// @ts-ignore

Vue.use(VueRouter)

const routes: Array<RouteConfig> = paths

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.afterEach(() => {
  if (
    // @ts-ignore
    window.layoutHelpers &&
    // @ts-ignore
    window.layoutHelpers.isSmallScreen() &&
    // @ts-ignore
    !window.layoutHelpers.isCollapsed()
  ) {
    // @ts-ignore
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("user-token")
  const details = localStorage.getItem("user-details")
  const publicPages = ["/"]
  const authRequired = !publicPages.includes(to.path)
  if (authRequired && (!token || !details)) next("/")
  else next()
})

export default router
